<template>
  <div>
    <base-card>
      <div class="tw-divide-y tw-divide-gray-200">
        <div class="tw-space-y-1">
          <h3 class="tw-text-lg tw-leading-6 tw-font-normal tw-text-gray-900 tw-mb-0">Personal Info</h3>
          <p class="tw-max-w-2xl tw-text-sm tw-text-gray-500">Manage how information is displayed on your account and how you're contacted</p>
        </div>
        <div class="tw-mt-6">
          <div class="tw-divide-y tw-divide-gray-200" v-if="isLoading">
            <div class="tw-py-2 sm:tw-py-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-for="i in 4" :key="`info-loading-${i}`">
              <base-skeleton-loader class="tw-h-2 sm:tw-my-auto sm:tw-h-3 tw-w-12 tw-mt-1" />
              <dd class="tw-mt-1 tw-flex tw-text-sm tw-text-gray-900 sm:tw-mt-0 sm:tw-col-span-3">
                <div class="tw-flex-grow tw-flex tw-items-center tw-my-px">
                  <base-skeleton-loader class="tw-h-3 tw-my-1.5 sm:tw-my-1 tw-w-24 tw-leading-6" />
                </div>
                <span class="tw-ml-4 tw-flex-shrink-0">
                  <base-skeleton-loader class="tw-h-5 tw-w-12" />
                </span>
              </dd>
            </div>
          </div>
          <dl class="tw-divide-y tw-divide-gray-200 tw-mb-0" v-else>
            <update-personal-info-full-name :user="user" @user-updated="$emit('user-updated', $event)" />
            <update-personal-info-email :user="user" @user-updated="$emit('user-updated', $event)" />
            <update-personal-info-phone-number :user="user" @user-updated="$emit('user-updated', $event)" />
            <update-personal-info-address :user="user" @user-updated="$emit('user-updated', $event)" />
          </dl>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import UpdatePersonalInfoFullName from "@/views/user/components/UpdatePersonalInfoFullName";
import UpdatePersonalInfoEmail from "@/views/user/components/UpdatePersonalInfoEmail";
import UpdatePersonalInfoPhoneNumber from "@/views/user/components/UpdatePersonalInfoPhoneNumber";
import UpdatePersonalInfoAddress from "@/views/user/components/UpdatePersonalInfoAddress";

export default {
  components: {
    UpdatePersonalInfoFullName,
    UpdatePersonalInfoEmail,
    UpdatePersonalInfoPhoneNumber,
    UpdatePersonalInfoAddress,
  },
  props: {
    isLoading: Boolean,
    user: Object,
  },
  data() {
    return {
      isUpdatingPersonalInfo: false,
      isPersonalInfoFormValid: true,
      fullName: "",
      email: "",
      mobile: "",
      isEditingFullName: false,
      isEditingEmail: false,
      isEditingMobile: false,
      isFullNameLoading: false,
      isEmailLoading: false,
      isMobileLoading: false,
    };
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler() {
        this.fullName = this.user.fullName;
        this.email = this.user.email;
        this.mobile = this.user.mobile;
      },
    },
  },
};
</script>
